import Page from '@app/components/layout/page/page';
import { useGetProcessing } from '@shared/api';
import ProcessingTable from './components/processing-table';

export interface Processing {
  createdDate: string;
  modifiedDate: string;
  description: string;
  notesAndAssumptions: string[];
  uuid: string;
}

const ProcessingPage: React.FC = () => {
  const data = useGetProcessing();

  return (
    <Page name="Processing" page="subpage">
      <ProcessingTable {...data} />
    </Page>
  );
};

export default ProcessingPage;
